import { useEffect, useState } from "react";

/**
 * Returns a value that updates to `value` only after `value` has stopped changing for `delayMs`.
 * Use for text that triggers server list/search API calls so requests are not sent on every keystroke.
 *
 * @param {unknown} value - Typically a string from a controlled search input
 * @param {number} [delayMs=400] - Quiet period before committing the value
 * @returns {unknown} The debounced value (initially same as first `value`)
 */
export function useDebounce(value, delayMs = 400) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebouncedValue(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);

  return debouncedValue;
}
